import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { StorageService } from '../../../services/storage.service'

@Component({
  selector: 'bmcore-cookie-policy-popup',
  templateUrl: './bmcore-cookie-policy-popup.component.html',
  styleUrls: ['./bmcore-cookie-policy-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreCookiePolicyPopupComponent implements OnInit {
  @Input() colorSettingsMode = false

  lg: LgType
  isCookiePolicyAccepted: boolean
  storageKeyCookiePolicy = 'cookie-policy'

  constructor(
    private i18nService: I18nService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.isCookiePolicyAccepted = this.storageService.load(this.storageKeyCookiePolicy) !== null
    this.lg = this.i18nService.getLanguageForPage()
  }

  acceptedCookie() {
    this.storageService.save(this.storageKeyCookiePolicy, true)
    this.isCookiePolicyAccepted = true
  }
}
